export default __webpack_public_path__ + "static/media/analytics-screen.af6d8bba.png";